import DashboardPageContainer from "../components/DashboardPageContainer/DashboardPageContainer";
import FormFromJson from "../../../common/FormFromJson/FormFromJson";
import DashboardHeader from "../components/DashboardHeader/DashboardHeader";

const MyBusiness = () => {
   return (
      <DashboardPageContainer>
         <DashboardHeader title={"My Business"} subtitle={""} />
         <FormFromJson jsonUrl="dashboard/my-business" />
      </DashboardPageContainer>
   );
};

export default MyBusiness;
